export const FORM_NAME = "vehicles";
export const STATE_NAME = "vehicles";
export const TAXABLE_VEHICLES_SLICE_NAME = "taxableVehiclesGrid";
export const CREDIT_VEHICLES_SLICE_NAME = "creditVehiclesGrid";
export const VEHICLE_EDITOR_FORM_NAME = "vehicle";
export const CREDIT_VEHICLE_EDITOR_FORM_NAME = "credit-vehicle";
